import React, { useEffect, useState } from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import ApiServices from 'services/ApiServices';
import Form from 'components/Form/FormTwoColumns';
import {useStyles} from './style';
import { Container, Divider, Grid } from '@material-ui/core';
import { functions } from "constants/index";
import {showMessagePersonalizedPosition, showMessageError} from 'services/SweetAlert'
import LoadingSpinner from 'components/LoadingSpinner';
import BotonPersonalizado from 'components/BotonNormal'
import { FindInPage } from '@material-ui/icons/';
import ComponenteDatosDeIdentidad from './DatosDeIdentidad'
import DialogLoadingMessage from 'components/LoadingMessage/index'

const  ConsultaRenapPorCui= (props)=> {
    const classes = useStyles(),
        [loading, setLoading] = useState(false),
        [datos, setDatos] = useState('');
    const [mensaje, setMensaje] = useState({loading: false, title:''});        
    let description = "Utilizar está consulta cuando no se encuentra datos del ciudadano(a) en la búsqueda de: \"BUSCAR CIUDADANO POR CUI DEL DPI\" de origen DELEGACIÓN/SUB-DELEGACIÓN"
    const catalogoTipoDeConsulta = [
        {id: 0, name: 'Solo consulta'},
        {id: 1, name: 'Consultar y guardar Información'},
    ]
    const keyPressCui = (event) => {
        if (event.key === "Enter") {
            if(event.target.value.length === 13){
                ConsultarDatosARenapPorCui()
            }
        }
    };

    const [elements,setElements] = React.useState({
        cui: { autofocus: true,
            idelement: "cui", value:'', label: "Número de CUI *", pattern:"^[0-9]{13,13}$", validators: ['required'], 
            errorMessages:['CUI requerido, sin espacios al inicio y final'], isError:false, elementType:'input' , keyPress: keyPressCui
        },
        soloconsulta: { 
            idelement: "soloconsulta", value:null , label: "Seleccione tipo de consulta *", pattern:"^[0-9-][0-9]*$", validators: ['required'], 
            errorMessages:['Seleccione tipo de consulta'], isError:false, elementType:'autocompleteV2', list: catalogoTipoDeConsulta,
        },        
    });

    const ConsultarDatosARenapPorCui = async () => {
        setDatos('')
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement( elements, setElements );
        if(allGood){
            setMensaje({loading: true, title: 'Consultando datos a RENAP por CUI del DPI No. '+ elements.cui.value})
            try {
                let saveData = {cui: elements.cui.value, soloconsulta: elements.soloconsulta.value?.id}
                let response = await ApiServices.ConsultaSolicitud.captacionDatosPorCui(saveData)
                if(response.error!==null){
                    showMessagePersonalizedPosition('warning', '¡Advertencia!', response.error.message, 'center')
                }
                else{
                    let arrayImagenes = []
                    arrayImagenes.push(
                        {existe: response.data.existeFirma, imagen: response.data.datosImagenes.firma, tipo: 'FIRMA', title: 'Firma: '},
                        {existe: response.data.existeFoto, imagen: response.data.datosImagenes.foto, tipo: 'FOTO', title: 'Fotografía'},
                        {existe: response.data.existeHuella, imagen: response.data.datosImagenes.huella, tipo: "HUELLA", title: 'Huella: '},
                    )
                    response.data.imagenes = arrayImagenes
                    setDatos(response.data)
                    showMessagePersonalizedPosition('success', '¡Bien!', response.data?.respuestaServicio, 'center')
                }
            } catch (error) {
                if(error.status===404) {
                    showMessagePersonalizedPosition('error', '¡Advertencia!', 'Falla del Sistema. póngase en contacto con el Administrador sí este mensaje persiste.', 'center')
                }else {
                    showMessagePersonalizedPosition('error', '¡Advertencia!', 'Intente de nuevo. póngase en contacto con el Administrador sí este mensaje persiste.', 'center')
                }                
            }  
            setMensaje({loading: false, title: ''})
        }
    };

    useEffect(() => {

    },[])
    return (
        <Container maxWidth="lg" className={classes.container}>        
            <DialogLoadingMessage open={mensaje.loading} title={mensaje.title}/>
            <Grid container >
                <div className={classes.colorComponente} style={{width: '100%', position: 'relative', overflow: 'auto', border: '1px solid  #cccccc', borderRadius: '20px', marginBottom:10,}} >
                    <Grid item xs={12}>
                        <div className={classes.centerTitle}><Divider /> <strong>Consulta por CUI del DPI</strong> <Divider /></div>
                    </Grid >
                    <Grid className={classes.description} item xs={12} container direction="row" justifyContent="center" alignItems="center">
                        <br></br>
                        {description}
                        <br></br><br></br>
                    </Grid>
                    <Grid item xs={12} container direction="row" justifyContent="left" alignItems="center">
                        <div className={classes.containerInformacion}>
                            <div><strong>Tipo de consulta</strong></div>
                                <div className={classes.listTitle}><strong>Solo consulta</strong></div>
                                    <div className={classes.listInfo}>La opción de "Solo consulta" al estar seleccionada únicamente se usará para poder ver la información.</div>
                                <div className={classes.listTitle}><strong>Consultar y guardar información</strong></div>
                                    <div className={classes.listInfo}>La opción de "Consultar y guardar información" muestra la información y además hace el guardado/actualización de la información del ciudadano.</div>
                        </div>
                    </Grid>
                    <Grid item xs={12} container direction="row" justifyContent="center" alignItems="center">
                        <Form   elements= {elements}/>
                    </Grid>
                    <Grid item xs={12} container direction="row" justifyContent="center" alignItems="center">
                        <BotonPersonalizado title={"Consultar"}  botonPersonalizado={true} function={ConsultarDatosARenapPorCui} icon={<FindInPage />}  /> 
                    </Grid>
                    {
                        (datos) && (
                            <ComponenteDatosDeIdentidad 
                                datos={datos}
                            />
                        )
                    }
                    <div className={classes.lineaDegradadaBottom}></div>
                </div>
            </Grid>
        </Container>
    );   
}
export default connect(mapStateToProps, mapDispatchToProps)(ConsultaRenapPorCui);